import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { PeopleListBloc } from '@connect-services/client/blocs/people-list.bloc';
import { ManagementListHeaderComponent } from '@connect-services/client/components/management/management-list-header/management-list-header.component';
import { AbstractNotificationSelectListComponent } from '@connect-services/client/components/management/notification/abstract-notification-select-list.component';
import { CheckboxComponent } from '@connect-services/client/lib/components/checkbox/checkbox.component';
import { PersonControllerGet200Response } from '@connect-services/client/sdk/api';
import { PaginatorComponent } from '@connect-services/src/lib/components/paginator/paginator.component';
import { RessourcesModule } from '@ressources/client/ressources.module';
import { LoadingComponent } from '@shared/client/components/loading/loading.component';
import { defaultPaginationParameters, OrderEnum, PaginationParameters } from '@shared/client/models/pagination.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CheckboxComponent, LoadingComponent, ManagementListHeaderComponent, PaginatorComponent, RessourcesModule],
    selector: 'app-notification-operator-select',
    standalone: true,
    templateUrl: './notification-operator-select.component.html',
})
export class NotificationOperatorSelectComponent extends AbstractNotificationSelectListComponent<
    PeopleListBloc,
    PersonControllerGet200Response
> {
    public override paginationParameters: PaginationParameters = {
        ...defaultPaginationParameters,
        order: OrderEnum.ASC,
        orderBy: 'givenName',
        take: 9,
    };
    protected readonly bloc = inject(PeopleListBloc);
}
